// export const baseUrl = process.env.BASE_URL || "http://localhost:80";
// export const baseUrl = process.env.BASE_URL || "http://192.168.1.101:80";
export const baseUrl = process.env.BASE_URL || "https://fm.manal.ae"; //almanal
// export const baseUrl = process.env.BASE_URL || "https://192.168.1.18"; //almanal

export const loginUrl = baseUrl + "/login";
export const signupUrl = baseUrl + "/signup";
export const forgotUrl = baseUrl + "/forgot";

export const attachment = baseUrl + "/attachment";

export const buildingAssets = baseUrl + "/asset";
export const buildingAssetLocation = baseUrl + "/asset/location";
export const buildingAssetSubLocation = baseUrl + "/asset/subLocation";
export const building = baseUrl + "/building";

export const currency = baseUrl + "/currency";
export const complaintSource = baseUrl + "/complaint/source";
export const complaintStatus = baseUrl + "/complaint/status";
export const complaintCategory = baseUrl + "/complaint/category";
export const complaintType = baseUrl + "/complaint/type";
export const contacts = baseUrl + "/contacts";
export const contactSource = baseUrl + "/contacts/source";
export const contactCategory = baseUrl + "/contacts/category";
export const contactSubCategory = baseUrl + "/contacts/subCategory";
export const complaint = baseUrl + "/complaint";
export const companyAll = baseUrl + "/company/all";
export const companyCategory = baseUrl + "/company/category";
export const companySubCategory = baseUrl + "/company/subCategory";
export const country = baseUrl + "/country";
export const city = baseUrl + "/city";
export const community = baseUrl + "/community";
export const cluster = baseUrl + "/cluster";
export const cheque = baseUrl + "/cheque";

export const division = baseUrl + "/division";
export const designation = baseUrl + "/designation";
export const developers = baseUrl + "/company/developers";
export const documentAttachment = baseUrl + "/document";

export const employeeRate = baseUrl + "/employee/rate";

export const faCategory = baseUrl + "/asset/category";
export const faSubCategory = baseUrl + "/asset/subCategory";

export const grade = baseUrl + "/grade";

export const transactions = baseUrl + "/transactions";

export const legalCompany = baseUrl + "/company/legal";
export const licenceType = baseUrl + "/licenceType";

export const maintenanceTeam = baseUrl + "/maintenance/team";
export const materialCategory = baseUrl + "/material/category";
export const materialItem = baseUrl + "/material/item";

export const phase = baseUrl + "/phase";
export const priority = baseUrl + "/priority";
export const project = baseUrl + "/project";

export const subStatus = baseUrl + "/complaint/status";
export const subCommunity = baseUrl + "/subCommunity";

export const tenancyContract = baseUrl + "/tenancy/contract";
export const title = baseUrl + "/title";

export const unit = baseUrl + "/unit";

export const unitHandoverVacating = baseUrl + "/handoverVacating";
export const rentalContractSettlementRequest =
  baseUrl + "/rental/contract/settlementRequest";

export const vatCountry = baseUrl + "/vatCountry";
export const vatEmirates = baseUrl + "/vatEmirates";
export const vwRentalTcList = baseUrl + "/rental/tc/list";

export const vwRentalCSRequest = baseUrl + "/rental/cs/view";

export const userPermission = baseUrl + "/user/permissions";

export const payrollCompany = baseUrl + "/payroll/company";
export const payrollBranch = baseUrl + "/payroll/branch";
export const payrollEmployee = baseUrl + "/payroll/employee";
